import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import { NgScrollbar } from 'ngx-scrollbar';
import { ContainsValuePipe } from '../../pipes/framework/contains-value.pipe';
import { commitmentsSelectors } from '../../store/commitments/commitments.selectors';
import { COMMITMENTS_INTERACTION_BAR_TYPE } from '../constants/interaction-bar.constants';
import { CurrentUserService } from '../../services/current-user.service';
import { MoneyPipe } from '../../pipes/framework/money-short.pipe';
import { SearchInputComponent } from '../search-input/search-input.component';
import { viewProjectSelectors } from '@app/store/view-project/view-project.selectors';
import { LineItemSummary } from '@app/services/project-spend.types';

export type SelectedOption = {
  action: 'select' | 'delete';
  item?: LineItemSummary; // todo check type
  name?: string;
  index?: number;
};

@Component({
  selector: 'app-budget-line-item-view-table-dropdown',
  templateUrl: './budget-line-item-view-table-dropdown.component.html',
  styleUrls: ['./budget-line-item-view-table-dropdown.component.scss'],
  imports: [CommonModule, ContainsValuePipe, NgScrollbar, MoneyPipe, SearchInputComponent],
})
export class BudgetLineItemViewTableDropdownComponent implements OnInit, OnDestroy {
  @Input() disabledLineItems: any[];
  @Input() commitmentType: COMMITMENTS_INTERACTION_BAR_TYPE;
  @Output() optionSelected = new EventEmitter<SelectedOption>();

  displayedLineItems: LineItemSummary[];
  budgetLineItems: LineItemSummary[];
  COMMITMENTS_INTERACTION_BAR_TYPE = COMMITMENTS_INTERACTION_BAR_TYPE;

  sidebarContract$ = this.store.select(commitmentsSelectors.getSidebarSelectedContractSummary);
  budgetLineItems$ = this.store
    .select(viewProjectSelectors.selectLineItemsSummary)
    .pipe(filter((value) => !!value));
  isDestroyed$ = new Subject();

  constructor(
    public user: CurrentUserService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.subscribeToChanges();
  }

  subscribeToChanges() {
    combineLatest([this.sidebarContract$, this.budgetLineItems$])
      .pipe(takeUntil(this.isDestroyed$))
      .subscribe(([contract, lineItems]) => {
        if (!contract || this.commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.ADD_CONTRACT) {
          this.budgetLineItems = lineItems;
        } else {
          this.budgetLineItems = lineItems.map((lineItem) => {
            const foundItem = contract.contract.commitment_items.find(
              (ci) => ci.item?.id === lineItem?.id,
            );
            return {
              ...lineItem,
              contractApproved: !!foundItem,
            };
          });
        }

        this.displayedLineItems = this.budgetLineItems;
      });
  }

  searchText(text: string) {
    console.log('search text', text, 'before', this.displayedLineItems);

    const searchText = text.toLowerCase();
    this.displayedLineItems = this.budgetLineItems.filter((item) =>
      item.name.toLowerCase().includes(searchText),
    );
  }

  ngOnDestroy() {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }
}
